<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-6">
<h1>Chapter 6</h1>
<p>James continues walking down the streets on the garbage-strewn sidewalks of his home community. His beard and short, black hair are lice-ridden, his olive-skin suntanned, and his teeth yellow and in need of care.</p>
<p>Intense heat from the sunlight makes him sweat profusely in the dying neighborhood around him.</p>
<p>“James…James Timewalker, is that you?” A limousine approaches, appearing oddly out of place in the decaying mess that became this tattered community. A man in his 30s, with a moustache and custom-made suit, popped his head out of the window.</p>
<p>“Hello, do I know you?” asks James, as he stops, wondering who knows his name, specifically someone wealthy enough to be in a limousine.</p>
<p>“It’s me, James. Cyrus Bilderberger. We went to Chronix Bay High together. Wow, you look…different,” Cyrus says with a shy frown. “What happened?”</p>
<p>“Life happened, I guess. The economy is rough and it’s tough to get work, and boy do I need some cash,” says James.</p>
<p>“I’m sorry, James. Let me help you.” Cyrus exits the limousine and reaches into his back pocket.</p>
<p>“No, Cyrus, I can’t take your money,” James speaks modestly, ashamed of his own sorry state of affairs.</p>
<p>“Actually, I was going to give you something better than money.” He takes out his wallet and opens it, pulling out a business card.</p>
<p>“Nothing is better than money,” laughs James, but then stops, as he saw Cyrus has a serious look upon his face. He hands James the business card taken out of the wallet.</p>
<p>“What’s this?” asks James.</p>
<p>“Possibly your future. You see, I run a Fortune 500 company in Superior City, and we need some good people for a special program we are starting, aimed at assisting disadvantaged members of society to get a better grasp on life,” says Cyrus.</p>
<p>“They don’t want me. I’m a junkie, I mean, recovering junkie, sort of by choice,” says James.</p>
<p>“We can help you get the help you need. Just think about it and call me. Here,” he gives James a quarter and then renters his limousine and smiles.</p>
<p>“Thanks,” says James.</p>
<p>“It is good seeing you again, James.” Cyrus waves, as the limousine drives off, leaving James still alone and homeless.</p>
<p>James looks at the card and smiles. “Temporo, Inc…. ‘Knowledge is power.’ That is interesting.”</p>
<p>James pockets the card and continues on his way toward no place in particular.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?7918a5bc